import React from 'react';
import { headerFooterData } from '../../../../Constants/HomePage';
import UsefulLinks from './UsefulLinks';
import {
  AboutLinkSection,
  AboutUs,
  LinksSection,
  LogoBg,
  MyloDescription,
  TrustedLine,
} from './styled';

export default function index() {
  return (
    <AboutLinkSection>
      <MyloDescription>
        <AboutUs>About Us</AboutUs>
        <LogoBg>
          {/* <LazyLoad height={100} once offset={100}> */}
          <img
            src="https://images.myloapp.in/NestJsUploads/1682404377508-myloLogo.svg"
            height="79"
            width="79"
            loading="lazy"
            title="Mylo Logo"
            alt="Mylo_logo"
          />
          {/* </LazyLoad> */}
        </LogoBg>
        <TrustedLine>
          At Mylo, we help young parents raise happy and healthy families with
          our innovative new-age solutions:
          <br />
          <ul className="list">
            <li>
              <strong>Mylo Care:</strong> Effective and science-backed personal
              care and wellness solutions for a joyful you.
            </li>
            <li>
              <strong>Mylo Baby:</strong> Science-backed, gentle and effective
              personal care & hygiene range for your little one.
            </li>
            <li>
              <strong>Mylo Community:</strong> Trusted and empathetic community
              of 10mn+ parents and experts.
            </li>
          </ul>
        </TrustedLine>
        {/* <PlaystoreButton /> */}
      </MyloDescription>
      <LinksSection>
        {headerFooterData.map((item, index) => {
          if (item.type === 0 || item.type === 2) {
            return (
              <UsefulLinks
                key={`footerLinks${index}`}
                id={`tab${index}`}
                data={item}
                initialChecked={index === 0}
              />
            );
          }
        })}
      </LinksSection>
    </AboutLinkSection>
  );
}
